import React, {Component} from 'react'
import Link from 'gatsby-link';

import {OutboundLink} from 'gatsby-plugin-google-analytics';

import iconFacebook from './../../img/icon-header-facebook.png';
import iconInstagram from './../../img/icon-header-instagram.png';
import iconYoutube from './../../img/icon-header-youtube.png';
import logo from './../../img/logo.png';
import arrowDown from './../../img/icon-arrow-down.png';
import BicenturyLink from "../link";

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {menuState: false, subMenu: false};
		this.data = props.data;
		this.lang = props.lang;
		this.translations = props.translations;
		if ("undefined" === typeof(this.data.navbarItems.top_left) || !this.data.navbarItems.top_left) {
			this.data.navbarItems.top_left = [];
		}
	}

	toggleMenu = () => {
		this.setState((prevState) => ({
			menuState: !prevState.menuState
		}))
	};

	// toggleSubMenu = () => {
	// 	this.setState((prevState) => ({
	// 		subMenu: !prevState.subMenu
	// 	}))
	// };

	closeMenu = () => {
		this.setState((prevState) => ({
			menuState: false
		}))
	};

	render() {
		const headerStatus = `header ${this.state.menuState ? 'active' : ''}`;
		const headerSubMenuStatus = `sub-items ${this.state.subMenu ? 'active' : 'active'}`;

		const listProducts = (child, idx) => {
			return (
				<li key={idx}>
					<Link to={`/${child.lang}${child.path}`} title="" onClick={this.closeMenu}>{child.title}</Link>
				</li>
			)
		};

		const navbarItem = (item, idx) => {
			if (item.text.trim()=='' || item.text.trim()=='-'){
				return (
					<li key={idx}>
					</li>
				);
			} else {
				return (
					<li key={idx}>
						<p>
							<BicenturyLink
								link={`/${item.link}`}
								text={`${item.text}`}
								type={item.linktype}
								lang={this.lang}
								onClick={this.closeMenu} />
						</p>
					</li>
				);
			}
		};

		return (
			<header className={headerStatus}>
				<div className="container-fluid">
					<div className="row">
						<div className="small-12 medium-12 large-3">
							<div className="logo-container">
								<Link to={`/${this.lang}`} title="Home" onClick={this.closeMenu}>
									<img src={logo}/>
								</Link>
							</div>
						</div>
						<div className="small-12 medium-12 large-9">
							<div className="menu-container">
								<ul className="menu">
									{
										this.data.navbarItems.top_left.map(navbarItem)
									}
									<li className={headerSubMenuStatus} style={{backgroundImage: `url(${arrowDown})`}} >
										<p>{this.translations.products}</p>
										<ul>
											{this.data.products.map(listProducts)}
										</ul>
									</li>
 									<li>
										<p>
											<Link
												to={`/${this.lang}/gustazos`}
												title="Gustazos"
												onClick={this.closeMenu}
											>{this.translations.gustazos}</Link>
										</p>
									</li>
									{
										this.data.navbarItems.top.map(navbarItem)
									}
									<li>
										<ul className="social">
											<li>
												<OutboundLink href="https://www.facebook.com/Bicentury/" title="Facebook" target="_blank">
													<img src={iconFacebook} alt="Facebook"/>
												</OutboundLink>
											</li>
											<li>
												<OutboundLink href="https://www.instagram.com/bicentury/" title="Instagram" target="_blank">
													<img src={iconInstagram} alt="Instagram"/>
												</OutboundLink>
											</li>
											<li>
												<OutboundLink href="https://www.youtube.com/user/BicenturyMKT" title="YouTube" target="_blank">
													<img src={iconYoutube} alt="YouTube"/>
												</OutboundLink>
											</li>
										</ul>
									</li>
								</ul>
							</div>
							<div className="menu-icon" onClick={this.toggleMenu}>
								<div/>
								<div/>
								<div/>
							</div>
						</div>
					</div>
				</div>
			</header>
		)
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js